<template>
  <div>
    <div v-for="(rule, index) in rules" :key="`${rule.title}${index}`" class="not-first:mt-4">
      <div class="font-bold mb-2">{{ rule.title }}</div>
      <BulletedList class="pl-3" :list="rule.contentList" />
    </div>
  </div>
</template>

<script setup lang="ts">
import BulletedList from '@/components/common/bulleted-list.vue'

interface Props {
  rules: {
    title: string
    contentList: string[]
  }[]
}

defineProps<Props>()
</script>
